'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var Vue = _interopDefault(require('vue'));
var KeyboardOptions = _interopDefault(require('./index'));

var instance = {
  create: function create() {
    if (!instance.keyboard) {
      instance.keyboard = new Vue(_objectSpread({}, KeyboardOptions, {
        el: document.createElement('div')
      }));
      instance.keyboard.$on('input', function (v) {
        instance.keyboard.value = instance.onChange(v);
      });
      instance.keyboard.$on('blur', function () {
        instance.blurTimer = window.setTimeout(function () {
          instance.hide();
        }, 150);
      });
      instance.keyboard.$on('confirm', function () {
        instance.onConfirm();
      });
      document.body.appendChild(instance.keyboard.$el);
    }
  },
  show: function show(config) {
    instance.create();
    window.clearTimeout(instance.blurTimer);
    instance.keyboard.value = '';
    instance.keyboard.show = true;
    this.update(config);
    instance.onConfirm = config.onConfirm;
    instance.onChange = config.onChange;
    instance.onBlur = config.onBlur;
  },
  update: function update(config) {
    if (!instance.keyboard) {
      return;
    }

    ['value', 'extraKey', 'extraKeyRight', 'maxLength', 'withButton', 'buttonText', 'buttonEnabled', 'keyboardTip', 'paySafeInfo'].forEach(function (key) {
      if (config[key] !== undefined) {
        instance.keyboard[key] = config[key];
      }
    });
  },
  hide: function hide() {
    instance.keyboard && (instance.keyboard.show = false);
  }
};

exports.default = instance;
